import { useEffect, type PropsWithChildren } from 'react';
import React from 'react';

import { useLDClient as useLDClientMobile } from '@launchdarkly/react-native-client-sdk';
import * as Sentry from '@sentry/react-native';

import {
  FLAG_MAINTENANCE_MODAL,
  USER_CONTEXT_ON_LAUNCHDARKLY,
} from './constants';
import { useMaintenanceModal } from './useMaintenanceModal';

const MaintenanceModeMobile = ({ children }: PropsWithChildren) => {
  const toggleMaintenanceModal = useMaintenanceModal();

  const ldClientMobile = useLDClientMobile();

  const showMaintenanceModal = ldClientMobile.boolVariation(
    FLAG_MAINTENANCE_MODAL,
    false,
  );

  useEffect(() => {
    ldClientMobile.identify(USER_CONTEXT_ON_LAUNCHDARKLY).catch((e) => {
      Sentry.captureException(e, {
        data: {
          message: 'Error on adding context to LaunchDarkly',
        },
      });
    });

    toggleMaintenanceModal(showMaintenanceModal);
  }, [showMaintenanceModal, ldClientMobile, toggleMaintenanceModal]);

  return <>{children}</>;
};

export { MaintenanceModeMobile };
